import Breadcrumb from "components/Common/Breadcrumb2"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { withTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import ListTemplates from "./Components/ListTemplates"
import NewTemplate from "./Components/NewTemplate"
import UpdateTemplate from "./Components/UpdateTemplate"
import { useUser } from "hooks/useUser"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { clientCapitalized } from "assets"

const Templates = props => {
  const { t } = props
  let { id } = useParams()
  let history = useHistory()
  const [activeTab, setActiveTab] = useState(id ? 2 : 0)
  const [reRenderList, setReRenderList] = useState(false)

  moment.locale("pt-br")
  document.title = `Templates de Exportação | Sensetek ${clientCapitalized}`

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={t("Exportação")}
            breadcrumbItems={[{ title: t("Templates"), path: "#" }]}
          />
          <Row>
            <Card>
              <CardBody>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Templates
                </CardHeader>
                <br className="mt-1" />
                <Nav pills className="navtab-bg nav-justified">
                  {activeTab !== 0 && <div className="vr"></div>}
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      active={activeTab === 0}
                      onClick={() => {
                        setReRenderList(!reRenderList)
                        history.push("/rastreio/exportacao/templates")
                        setActiveTab(0)
                      }}
                    >
                      Lista de Templates
                    </NavLink>
                  </NavItem>
                  <div className="vr"></div>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      active={activeTab === 1}
                      onClick={() => {
                        setActiveTab(1)
                      }}
                    >
                      Novo Template
                    </NavLink>
                  </NavItem>
                  {activeTab !== 1 && <div className="vr"></div>}
                </Nav>
                <TabContent activeTab={activeTab} className="p-3 text-muted">
                  <TabPane tabId={0}>
                    <Row>
                      <Col sm="12">
                        <ListTemplates
                          reRender={reRenderList}
                          setNav={setActiveTab}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={1}>
                    <Row>
                      <Col sm="12">
                        <NewTemplate
                          reRender={reRenderList}
                          setNav={setActiveTab}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={2}>
                    <Row>
                      <Col sm="12">
                        {id && (
                          <UpdateTemplate
                            reRender={reRenderList}
                            setNav={setActiveTab}
                          />
                        )}
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Templates.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Templates)
